import Server from './callServer'
import ApiEndpoint from './api_endpoints'

const serverData = {
  login: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.login,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  activateAccount: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.activateaccount,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  signup: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.signup,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  signupCompanyDetails: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.signupCompanyDetails,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getEmailOPT: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getEmailOPT,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  verifyOTP: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.verifyOTP,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getJobPostDropDownValues: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getjobpostdropdownvalues,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getCountries: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getCountries,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getJobPosts: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getJobPosts,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  postJob: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.postJob,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  editPostedJob: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.editPostedJob,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  closeJob: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.closeJob,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  discardJob: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.discardJob,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  // recruiter
  getSearchJob: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.searchJobs,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getPreQuestions: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.preQuestions,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getRejectedReasons: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.rejectedReasons,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  worklist: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.addToWorklist,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  worklistData: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getWorklist,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  removeFromWorklist: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.removeFromWorklistURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  removeReasonFromWorklist: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.removeReasonFromWorklistURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  submitCandidate: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.submitCandidateURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      },
      true
    )
  },
  workedOnData: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getWorkOnURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getSubEmployers: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getSubEmployers,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  checkCandiate: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.checkCandidateURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getTrackCandidates: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getCandidateURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  EditCandidate: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.editCandidateURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      },
      true
    )
  },
  candidatePostApplicationEmail: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.candidatePostApplicationEmailURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  resentCandidateRTRmail: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.resentCandidateApplicationEmailURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getJobDetailsForCandidate: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getJobDetailsForCandidateURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  approveCandidateApplication: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.approveCandidateApplicationURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  rejectCandidateApplication: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.rejectCandidateApplicationURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  editEmployerProfile: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.editEmployerProfileURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      },
      true
    )
  },

  getProfileData: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getProfileData,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getDashboardData: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getDashboardData,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getApplicationsForReview: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getApplicationsForReviewURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  changeJoiningDate: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.changeJoiningDate,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  changeApplicationStatus: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.changeApplicationStatusURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getRecruiterDashboardData: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getRecruiterDashboardData,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getReferralEarnings: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getReferralEarningsURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  logout: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.logout,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  changePassword: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.changepassword,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  forgotPassword: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.forgotpassword,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  resetPassword: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.resetpassword,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getNotificationData: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getNotificationDataURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getJobsPostedByEmployer: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getJobsPostedByEmployer,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  markAsReadNotification: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.markAsReadNotification,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getNotificationsCount: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getNotificationsCount,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  updateHiredApplicationStatus: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.updateHiredApplicationStatus,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  putOnHoldOrActive: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.putOnHoldOrActiveURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  candidateUpdateApplication: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.candidateUpdateApplicationURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      },
      true
    )
  },
  feedbackOnRecruiter: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.feedbackOnRecruiterURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getTransactions: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getTransactions,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  addSubEmployer: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.addSubEmployerURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  assignSubEmployer: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.assignSubEmployerURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getRecruiterProfile: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getRecruiterProfile,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  updateRecruiterProfile: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.updateRecruiterProfile,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getMyFunctionalRoles: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getMyFunctionalRoles,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getFAQs: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getFAQurl,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getEmailPreferences: async (body, success, failure) => {
    await Server.getRequest(
      ApiEndpoint.getEmailPreferences,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  updateEmailPreferences: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.updateEmailPreferences,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  sendMessage: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.sendMessage,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  setPasswordSubEmployer: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.setPasswordSubEmployer,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  markMessageAsSeen: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.markMessageAsSeen,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  resendSubEmployerEmail: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.resendSubEmployerEmail,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  editMessage: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.editMessage,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  deleteMessage: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.deleteMessage,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  deleteQuestionFromLibrary: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.deleteQuestionFromLibrary,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getStateAndCityByZipcode: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getStateAndCityByZipcode,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },

  getStateAndCityByZipcodeUsers: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getStateAndCityByZipcodeUsers,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getSkillSuggestions: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getSkillSuggestionsURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  submitEmployeeFeedback: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.submitEmployeeFeedbackURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  },
  getEmployeeFeedback: async (body, success, failure) => {
    await Server.postRequest(
      ApiEndpoint.getEmployeeFeedbackURL,
      body,
      result => {
        success(result)
      },
      error => {
        failure(error)
      }
    )
  }
}

export default serverData
